<h3-layer-view-settings-popover>
  <ng-container projection-location="sliders">
    <h3-objectless-view-settings-opacity-slider
      [defaultLayerOpacity]="defaultLayerOpacity"
    ></h3-objectless-view-settings-opacity-slider>
    <h3-objectless-view-settings-slider
      [default]="defaultPointSize"
      [max]="5"
      [min]="1"
      [nasModel]="pointSizeStore"
      [settingStore]="pointSizeStore"
      [step]="0.1"
      class="form-group"
      label="Point size"
      setting="point_size"
      suffix="px"
    ></h3-objectless-view-settings-slider>
  </ng-container>
</h3-layer-view-settings-popover>
